import { Endpoints } from 'modules/core/constants';
import { AxiosResponse } from 'axios';
import { Api } from 'api/api';
import {
  IControlImagesPayload,
  IControlNumbersPayload,
  IFooterData,
  IRouteOneMaintenancePayload,
} from 'modules/core/types/common';
import { CreditScore } from 'modules/ProbabilityEstimator/types/creditScore.type';
import { IFeesAndTaxesPayload, ITier } from 'modules/core/types';
import { ISubventionYear } from 'modules/ApprovedLoanInput/types';
import { IAdjustEventMessagesPayload } from 'components/Modals/VehicleAdjustmentDialog/types';
import { IRegionControlsPayload } from 'modules/core/types/region';
import { ILenderControlsPayload } from 'modules/core/types/lender';

class ControlApi extends Api {
  getFooterData = (): Promise<AxiosResponse<IFooterData>> => this.api.get(Endpoints.getFooterData);

  getFeesAndTaxesData = (): Promise<AxiosResponse<IFeesAndTaxesPayload>> => this.api.get(Endpoints.getFeesAndTaxesData);

  getSubventionYearData = (): Promise<AxiosResponse<ISubventionYear[]>> =>
    this.api.get(Endpoints.getSubventionYearData);

  getInterestRateList = (): Promise<AxiosResponse<CreditScore[]>> => this.api.get(Endpoints.getInterestRateList);

  getAdjustEventMessages = (): Promise<AxiosResponse<IAdjustEventMessagesPayload[]>> =>
    this.api.get(Endpoints.getAdjustEventMessages);

  getControlNumbers = (): Promise<AxiosResponse<IControlNumbersPayload>> => this.api.get(Endpoints.getControlNumbers);

  getControlImages = (): Promise<AxiosResponse<IControlImagesPayload>> => this.api.get(Endpoints.getControlImages);

  getRouteOneMaintenance = (): Promise<AxiosResponse<IRouteOneMaintenancePayload>> =>
    this.api.get(Endpoints.getRouteOneMaintenance);

  getTierOptions = (params: Record<string, unknown>): Promise<AxiosResponse<ITier[]>> =>
    this.api.get(Endpoints.getTierOptions, { params });

  getRegionControls = (params: Record<string, unknown>): Promise<AxiosResponse<IRegionControlsPayload>> =>
    this.api.get(Endpoints.getRegionControls, { params });

  getLenderControls = (): Promise<AxiosResponse<ILenderControlsPayload>> => this.api.get(Endpoints.getLenderControls);

  getStateRegions = (): Promise<AxiosResponse<string[]>> => this.api.get(Endpoints.getStateRegions);
}

export default new ControlApi();
